import { GetDeliveryOptionsResponse } from '../api'

export const resolveEstimatedDeliveryDate = (
  deliveryMethod: string,
  deliveryType: string,
  deliveryOptionsResponse?: GetDeliveryOptionsResponse
) => {
  const shipments = deliveryOptionsResponse?.shipments;
  if (!shipments || shipments.length === 0) {
    return undefined;
  }

  // Check if the deliveryMethod/deliveryType combination exists in ALL shipments
  const isInAllShipments = shipments.every(shipment =>
    shipment.deliveryOptions?.some(option =>
      option?.shippingDetails.deliveryMethod === deliveryMethod &&
      option?.shippingDetails.deliveryType === deliveryType
    )
  );

  if (!isInAllShipments) {
    return undefined;
  }

  // If present in all shipments, collect all matching delivery options
  const deliveryOption = shipments
    .map((s) => s.deliveryOptions)
    .flat()
    .map((deliveryOption) => ({
      estimatedDeliveryDate: deliveryOption?.estimatedDeliveryDate!,
      deliveryMethod: deliveryOption?.shippingDetails.deliveryMethod!,
      deliveryType: deliveryOption?.shippingDetails.deliveryType!,
    }))
    .filter((deliveryOption) => deliveryOption.deliveryMethod === deliveryMethod && deliveryOption.deliveryType === deliveryType)

  return deliveryOption !== undefined && deliveryOption.length > 0
    ? deliveryOption?.reduce((max, x) => (max.estimatedDeliveryDate > x.estimatedDeliveryDate ? max : x)).estimatedDeliveryDate
    : undefined
}
